import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-viz-description',
  templateUrl: './viz-description.component.html',
  styleUrls: ['./viz-description.component.scss'],
})
export class VizDescriptionComponent implements OnInit {


  ngOnInit(): void {}
}
